import * as Yup from "yup";
import { Campaign } from "../../share/campaigns/store";
import { checkCampaignExist } from "../../helpers";

const CAMPAIGN_NAME_FIELD_LENGTH = 500;
const CAMPAIGN_DESCRIPTION_FIELD_LENGTH = 2000;

const strategyValidator = Yup.string()
  .required("Strategy is required")
  .min(100, "Please give us more information");

// Yup.string().url() is very strict, not allowing urls without the protocol (http/https)
//  For this, we simply check if the value starts by one of the protocols, and if not
//  add it to bypass this strictness
const lookalikesValidator = Yup.array().of(
  Yup.string()
    .transform((currentValue) => {
      const doesNotStartWithHttp =
        currentValue &&
        !(
          currentValue.startsWith("http://") ||
          currentValue.startsWith("https://")
        );

      if (doesNotStartWithHttp) {
        return `http://${currentValue}`;
      }
      return currentValue;
    })
    .url("That doesn't look like a correct URL")
);

const keywordsValidator = Yup.array()
  .min(1, "Topics are required for the algorithm")
  .of(Yup.string());

export const ExploreCampaignSchema = (campaigns: Campaign[]) => {
  return Yup.object().shape({
    strategyPlainText: strategyValidator,
    lookalikes: lookalikesValidator,
    keywords: keywordsValidator,
    countries: Yup.array().of(Yup.string()),
    requestPatentsInfo: Yup.boolean(),
    activate: Yup.boolean(),
  });
};

export const ClustersSchema = (campaigns: Campaign[], isBetaTester?: boolean) =>
  Yup.object().shape({});

export const ConfirmCampaignSchema = (campaigns: Campaign[]) =>
  Yup.object().shape({
    strategyPlainText: strategyValidator,
    lookalikes: lookalikesValidator,
    keywords: keywordsValidator,
    name: Yup.string()
      .required("Campaign name is required.")
      .max(
        CAMPAIGN_NAME_FIELD_LENGTH,
        `Campaign description cannot exceed ${CAMPAIGN_NAME_FIELD_LENGTH} characters`
      )
      .test("exist", "A campaign with that name already exists.", (value) =>
        checkCampaignExist(campaigns, value)
      ),
    description: Yup.string(),
  });

export const EditCampaignSchema = (
  campaigns: Campaign[],
  campaignUUID: string
) =>
  Yup.object().shape({
    name: Yup.string()
      .required("Campaign name is required.")
      .max(
        CAMPAIGN_NAME_FIELD_LENGTH,
        "Campaign name cannot exceed 500 characters"
      )
      .test("exist", "A campaign with that name already exists", (value) =>
        checkCampaignExist(campaigns, value, campaignUUID)
      ),
    description: Yup.string().max(
      CAMPAIGN_DESCRIPTION_FIELD_LENGTH,
      `Campaign description cannot exceed ${CAMPAIGN_DESCRIPTION_FIELD_LENGTH} characters`
    ),
  });

// Used for New campaign Step 4 "validation"
export const EmptySchema = () => Yup.object().shape({});
